module.exports = __webpack_public_path__ + "img/sergey.5b8a28a8.png";